'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { openWindow } from '@benzinga/frontend-utils';
import styles from './Billing.module.css';

const BILLING_SUPPORT_EMAIL = 'vipaccounts@benzinga.com';

export function BillingSupport() {
  const { t } = useTranslation(['profile', 'common']);

  const openChat = (): void => {
    if (window.Intercom) {
      window.Intercom('show');
      return;
    }
    openWindow(
      'https://pro.benzinga.com/helpchat/',
      'Benzinga Help Chat',
      'width=425,height=550,left=0,resizable',
      undefined,
      { free: true },
    );
  };

  return (
    <div className="acct-card">
      <div className={styles.support}>
        <div>
          <h3 className={styles.cardTitle}>
            {t('Billing.support-title', { defaultValue: 'Questions about a charge or plan?', ns: 'profile' })}
          </h3>
          <p className={styles.empty}>
            {t('Billing.support-sub', {
              defaultValue: 'Our support team can help with billing, refunds, and plan changes.',
              ns: 'profile',
            })}
          </p>
        </div>
        <div className={styles.supportActions}>
          <span>
            {t('Billing.support-email', { defaultValue: 'Email', ns: 'profile' })}{' '}
            <a className={styles.contactLink} href={`mailto:${BILLING_SUPPORT_EMAIL}`}>
              {BILLING_SUPPORT_EMAIL}
            </a>{' '}
            {t('Billing.support-or', { defaultValue: 'or', ns: 'profile' })}
          </span>
          <button className={styles.btnSecondary} onClick={openChat} type="button">
            {t('Billing.support-chat', { defaultValue: 'Chat with us', ns: 'profile' })}
          </button>
        </div>
      </div>
    </div>
  );
}
